import { getBrowserId, getCloudSDKSettingsBrowser as getCloudSDKSettings, getEnabledPackageBrowser as getEnabledPackage, getSettings, handleGetSettingsError } from '@sitecore-cloudsdk/core/internal';
import { getCookieValueClientSide } from '@sitecore-cloudsdk/utils';
import { ErrorMessages, PACKAGE_NAME } from '../../consts';
import { awaitInit } from '../../init/browser/initializer';
import { sendEvent } from '../send-event/sendEvent';
import { PageViewEvent } from './page-view-event';
/**
 * A function that sends a VIEW event to SitecoreCloud API
 *
 * @param pageViewData - The optional attributes in order to be send to SitecoreCloud API
 * This object will be flattened and sent in the ext object of the payload
 * @returns The response object that Sitecore EP returns
 */
export async function pageView(pageViewData) {
    await awaitInit();
    if (getEnabledPackage(PACKAGE_NAME)?.initState) {
        const settings = getCloudSDKSettings();
        const id = getCookieValueClientSide(settings.cookieSettings.name.browserId);
        return new PageViewEvent({
            id,
            pageViewData,
            searchParams: window.location.search,
            sendEvent,
            settings: settings
        }).send();
    }
    else {
        const settings = handleGetSettingsError(getSettings, ErrorMessages.IE_0014);
        const id = getBrowserId();
        return new PageViewEvent({
            id,
            pageViewData,
            searchParams: window.location.search,
            sendEvent,
            settings
        }).send();
    }
}
